import { Card } from 'semantic-ui-react';
import styled from 'styled-components';

export const BoxContainer = styled(Card)`
  // box-shadow: 0px 3px 20px rgb(0 0 0 / 4%) !important;
  box-shadow: none !important;
  border-radius: 0.375rem !important;
  border-color: transparent !important;

  .content {
    > :first-child:not(.equal) {
    }

    .header {
      font-size: 1.2rem !important;
      line-height: 1.5rem !important;
      font-weight: 600 !important;
      color: rgb(30 41 59) !important;
      margin: 0.5rem 0 !important;
      margin-right: auto !important;
    }
  }
`;
